import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "react-app-polyfill/ie9";
import * as serviceWorker from "./serviceWorker";
import "./index.css";
import { store, persistor } from "./redux-tools/configureStore";
import App from "./App";
import { ThemeProvider } from "@material-ui/styles";
import { CssBaseline } from "@material-ui/core";
import { useTheme } from "./hooks/useTheme";
import { getColorScheme } from "./Components/Common/Utility";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
require("dotenv").config();

const AppWithTheme = () => {
  const { theme } = useTheme();

  // Initialize Zendesk help widget theme
  if (window.zESettings && window.zESettings.webWidget) {
    window.zESettings.webWidget["color"]["theme"] = getColorScheme();
    window.zESettings.webWidget["color"]["launcherText"] = "#fafafa";
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <App theme={theme} />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  );
};

ReactDOM.render(
  <AppWithTheme />,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
